import { useState } from 'react';

export function usePagination(defaultAscending = true) {
  const DEFAULT_PAGINATOR_STATE = {
    currentPage: 1,
    totalPages: 1,
    rows: 10,
  };

  const DEFAULT_PAGINATION_PARAMETERS = {
    order: {
      isAscending: defaultAscending,
      orderColumn: '',
    },
    page: {
      index: 1,
      size: 10,
    },
  };

  const [paginatorState, setPaginatorState] = useState(DEFAULT_PAGINATOR_STATE);

  const [paginationParameters, setPaginationParameters] = useState(DEFAULT_PAGINATION_PARAMETERS);

  const handlePageChange = (pageNumber) => {
    setPaginatorState((prevState) => ({ ...prevState, currentPage: pageNumber }));
    setPaginationParameters((prevState) => {
      const clone = structuredClone(prevState);
      clone.page.index = pageNumber;
      return clone;
    });
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    setPaginatorState((prevState) => ({ ...prevState, currentPage: 1, rows: rowsPerPage }));
    setPaginationParameters((prevState) => {
      const clone = structuredClone(prevState);
      clone.page.index = 1;
      clone.page.size = rowsPerPage;
      return clone;
    });
  };

  return {
    paginatorState,
    setPaginatorState,
    paginationParameters,
    setPaginationParameters,
    handlePageChange,
    handleRowsPerPageChange,
  };
}
